import { render, staticRenderFns } from "./ColdClientStatistics.vue?vue&type=template&id=c55813d2&scoped=true&"
import script from "./ColdClientStatistics.vue?vue&type=script&lang=js&"
export * from "./ColdClientStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ColdClientStatistics.vue?vue&type=style&index=0&id=c55813d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55813d2",
  null
  
)

export default component.exports